import { useMemo } from "react";

import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import {
  formatMetric,
  type MetricPrecision,
} from "@north-beam/nb-common/formatting";
import { useClientSettings } from "@pages/mmm/hooks/use-client-settings";

import { Slider } from "../../../targets/slider";
import { type TableRowType } from "../performance-tracking-table";

export const SpendThermometerDataFormatter = ({
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as TableRowType;
  const { user } = useUser();
  const { formattedMixToDateRange, formattedCycleDateRange } =
    useClientSettings();

  const actual = row.data.actualSpend;
  const budgeted = useMemo(
    () => row.data.budgetedSpendToDate,
    [row.data.budgetedSpendToDate],
  );

  const target = row.data.budgetedSpend;
  const formatter = (val: number, precision: MetricPrecision = "approximate") =>
    formatMetric(val, "dollars", {
      precision,
      code: user.currencies.currentCurrency,
    });

  return (
    <div className="flex justify-center items-center h-24 px-3 font-sans overflow-hidden">
      <div className="w-full">
        <Slider
          smallAnnotations
          actualColor="#C825A8"
          actual={actual}
          actualText="SPENT"
          budgeted={budgeted}
          budgetedText="BUDGET"
          target={target}
          dateRangeText={formattedMixToDateRange}
          formatter={formatter}
          targetIconTooltipContent={
            <div className="font-semibold">
              <div className="text-xs tracking-wide mb-1">
                TOTAL PERIOD BUDGET
              </div>
              <div className="text-gray+2 font-normal">
                {formattedCycleDateRange}
              </div>
              <div className="text-lg text-cosmic">
                {formatter(target, "exact")}
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};
